/* eslint-disable no-unused-vars, jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import RadioButtonGroup from "pages/forms/_components/_fields/_commons/RadioButtonGroup";
import { func, shape, bool, string } from "prop-types";

export default function FundcorpFilterSelect({
    columnFilter,
    changeFilter,
    isDesktop,
    options,
    radioOptions,
    className,
    cleanFilter,
    setCleanFilter,
}) {
    const [state, setState] = useState({
        ascendent: true,
        descendent: false,
        selectedFilter: null,
        selectedValue: "1",
    });

    FundcorpFilterSelect.propTypes = {
        columnFilter: shape({}),
        options: shape({}).isRequired,
        radioOptions: shape({}).isRequired,
        changeFilter: func.isRequired,
        isDesktop: bool.isRequired,
        className: string,
        cleanFilter: bool.isRequired,
        setCleanFilter: func.isRequired,
    };

    FundcorpFilterSelect.defaultProps = {
        columnFilter: { filterSelected: "amount" },
        className: "",
    };

    const hasMounted = useRef(false);

    const changeOrder = (value) => {
        setState((s) => ({ ...s, selectedValue: value }));

        if (state.selectedFilter.value) {
            if (value === "0") {
                setState((s) => ({ ...s, ascendent: true, descendent: false }));
                changeFilter(state.selectedFilter.value, "ascendent");
            } else {
                setState((s) => ({ ...s, ascendent: false, descendent: true }));
                changeFilter(state.selectedFilter.value, "descendent");
            }
        }
    };

    useEffect(() => {
        const newColumnFilter = { ...columnFilter };
        if (state.selectedValue === "0") {
            newColumnFilter.directionFilter = "ascendent";
        } else {
            newColumnFilter.directionFilter = "descendent";
        }

        if (columnFilter && columnFilter.filterSelected === state.selectedFilter) {
            if (newColumnFilter.directionFilter === "ascendent") {
                setState((s) => ({ ...s, descendent: false }));
            } else {
                setState((s) => ({ ...s, ascendent: false }));
            }
        } else {
            setState((s) => ({ ...s, ascendent: true, descendent: false }));
        }

        if (cleanFilter) {
            setState((s) => ({
                ...s,
                selectedFilter: options[0],
                selectedValue: "0",
                ascendent: false,
                descendent: true,
            }));
            setCleanFilter(false);
        }

        if (!hasMounted.current) {
            hasMounted.current = true;
            if (columnFilter) {
                setState((s) => ({
                    ...s,
                    selectedFilter: options.find((opt) => opt.value === columnFilter.filterSelected),
                    selectedValue: columnFilter.directionFilter === "ascendent" ? "0" : "1",
                    ascendent: columnFilter.directionFilter === "ascendent",
                    descendent: columnFilter.directionFilter === "descendent",
                }));
            } else {
                setState((s) => ({
                    ...s,
                    selectedFilter: options[0],
                    selectedValue: "1",
                    ascendent: false,
                    descendent: true,
                }));
            }
        } else if (options.length > 0 && !options.some((opt) => opt.value === state.selectedFilter?.value)) {
            setState((s) => ({ ...s, selectedFilter: options[0] }));
        }
    }, [columnFilter, state.selectedFilter, state.selectedValue, cleanFilter, setCleanFilter, changeFilter, options]);

    const handleChange = (selectFilter) => {
        setState((s) => ({ ...s, selectedFilter: selectFilter }));
        if (selectFilter.value) {
            const direction = state.selectedValue === "0" ? "ascendent" : "descendent";
            if (direction === "ascendent") {
                setState((s) => ({ ...s, ascendent: false, descendent: true }));
            } else {
                setState((s) => ({ ...s, ascendent: true, descendent: false }));
            }
            changeFilter(selectFilter.value, direction);
        }
    };

    return (
        <div className="px-0 pr-3">
            <div className="pl-0">
                <div className="form-group-text">
                    <label htmlFor="activity" className="control-label">
                        <I18n id="transactions.list.filters.transaction.orderby.label" />
                    </label>
                </div>
                <div className={`pending-transactions__orderby ${className}`}>
                    <div className="input-group mr-3">
                        <Select
                            name="activity"
                            className="slideFromBottom"
                            clearable={false}
                            searchable={isDesktop}
                            onChange={handleChange}
                            options={options}
                            optionClassName="needsclick"
                            placeholder={i18n.get("transactions.filters.placeholder")}
                            value={state.selectedFilter}
                            defaultValue={state.selectedFilter}
                            noResultsText={i18n.get("global.no.results")}
                        />
                    </div>
                    <RadioButtonGroup
                        inLineControl
                        name="radioGroup"
                        selectorId="radioGroup"
                        onChange={changeOrder}
                        optionClassName="needsclick"
                        options={radioOptions}
                        value={state.selectedValue}
                        valueKey="id"
                        labelKey="label"
                    />
                </div>
            </div>
        </div>
    );
}
